import Vue from 'vue';
import invoiceRequest from './invoice-request/invoice-request.vue';
Vue.component('invoice-request', invoiceRequest);
